import { useState, useEffect } from 'react';
import { _EmployeeContract, _single, _SocialSecurityType } from '../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { MASK_NUMBER } from '../../../theme/Component/BasicTable';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';

interface Props {
    label?:string;
    idSelector: number;
    onChange: any;
}

export const SocialSecurityTypeConstants = ({ idSelector, label,onChange }: Props) => {

    const service = useDataBean(_SocialSecurityType);
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(null);
    const modal = useModal("Editar",MODAL_LG);

    useEffect(() => {
        getLista();
    }, [])

    useEffect(() => {
        if(idSelector)
        if(idSelector)
            setID(idSelector);

    }, [idSelector])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));
    }

    const getLista = () => {

     
            service.instance.getSocialSecurityTypeConstants().then(
                (resp:any)=>{
                    if (resp) {
                        setLista(resp);                        
                    }
                }
            )

    };

    

    return (
        <>
            <label >{label ?? 'Tipo de Seguridad Social'}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any,index:number) => {
                        return (
                            <>
                                <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                            </>)
                    })
                }
            </select>
        </>
    )
}
